<template>
  <div class="relay">
    <div class="relay__header">
      <v-icon color="primary" class="relay__header-icon">mdi-lock-outline</v-icon>
      <h2 class="relay__title">Замки</h2>
      <v-spacer />
      <v-select
        v-model="lockModes"
        :items="lockMode"
        item-text="text"
        item-value="value"
        label="Режим работы коммутатора"
        outlined
        dense
        flat
        prepend-inner-icon="mdi-tune-variant"
        class="relay__mode-select"
        hide-details
      />
      <v-menu v-if="$checkPermission('import_relay')" bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            outlined
            rounded
            class="text-none ml-3"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>mdi-import</v-icon>
            Импорт
          </v-btn>
        </template>
        <v-list width="300" dense>
          <v-list-item @click.prevent="importRelayData()">
            <v-list-item-title>Импорт из девайса</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-container class="ml-0 pt-0">
      <v-form ref="formRelay" v-model="validRelay" lazy-validation>
        <v-row>
          <v-col cols="10" md='8' class="pb-0">
            <template>
              <v-container class="grey lighten-5">
                <v-row>
                  <v-col sm="3">
                    Идентификатор реле
                  </v-col>
                  <v-col sm="3" align="center">
                    Реле A
                  </v-col>
                  <v-col sm="3" align="center">
                    Реле B
                  </v-col>
                  <v-col sm="3" align="center">
                    Реле C
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="3">
                    Тип реле
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="types"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayAType'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="types"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayBType'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="types"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayCType'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col sm="3">
                    Задержка открытия реле(sec)
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="delays()"
                      v-model='formRelay.relayADelay'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="delays()"
                      v-model='formRelay.relayBDelay'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="delays()"
                      v-model='formRelay.relayCDelay'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="dtmfEnabled">
                  <v-col sm="3">
                    Настройка DTMF
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="options"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.dtmfOption'
                      v-on:change="selectOption()"
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="dtmfEnabled">
                  <v-col sm="3">
                    DTMF-команда
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="commands"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayADtmf'
                      outlined
                      dense
                      hide-details
                      :disabled="commandDisabled"
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="commands"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayBDtmf'
                      outlined
                      dense
                      hide-details
                      :disabled="commandDisabled"
                    ></v-select>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="commands"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayCDtmf'
                      outlined
                      dense
                      hide-details
                      :disabled="commandDisabled"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="dtmfEnabled">
                  <v-col sm="3">
                    Дополнительные DTMF-команды
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-text-field
                      v-model="formRelay.relayAMulticode"
                      outlined
                      dense
                      :disabled="multicodeDisabled"
                      :rules="validateMulticode(formRelay.relayAMulticode)"
                      maxlength="4"
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-text-field
                      v-model="formRelay.relayBMulticode"
                      outlined
                      dense
                      :disabled="multicodeDisabled"
                      :rules="validateMulticode(formRelay.relayBMulticode)"
                      maxlength="4"
                    ></v-text-field>
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-text-field
                      v-model="formRelay.relayCMulticode"
                      outlined
                      dense
                      :disabled="multicodeDisabled"
                      :rules="validateMulticode(formRelay.relayCMulticode)"
                      maxlength="4"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="dtmfEnabled">
                  <v-col sm="3">
                    Открытие реле через HTTP
                  </v-col>
                  <v-col sm="3" class="pa-2">
                    <v-select
                      :items="statuses"
                      item-text="text"
                      item-value="value"
                      v-model='formRelay.relayOnWeb'
                      outlined
                      dense
                      hide-details
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>
        </v-row>
        <div class="relay__actions">
          <v-btn
            color="primary"
            class="text-none"
            rounded
            @click="saveRelay()"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            Сохранить
          </v-btn>
          <v-btn
            color="primary"
            outlined
            rounded
            class="text-none ml-2"
            @click.prevent="returnDoorphone && returnDoorphone()"
          >
            <v-icon left>mdi-close</v-icon>
            Отменить
          </v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['returnDoorphone'],
  name: 'Relay',
  data () {
    return {
      validRelay: true,
      dtmfEnabled: false,
      commandDisabled: false,
      multicodeDisabled: false,
      lockModes: '',
      formRelay: {
        dtmfOption: '',
        relayAType: '',
        relayADelay: '',
        relayADtmf: '',
        relayAMulticode: '',
        relayBType: '',
        relayBDelay: '',
        relayBDtmf: '',
        relayBMulticode: '',
        relayCType: '',
        relayCDelay: '',
        relayCDtmf: '',
        relayCMulticode: '',
        relayOnWeb: '',
      },
      lockMode: [
        { text: 'По умолчанию', value: 'D' },
        { text: 'Инверсия', value: 'I' },
      ],
      types: [
        { text: 'По умолчанию', value: 0 },
        { text: 'Инверсное', value: 1 },
      ],
      options: [
        { text: '1 цифра', value: 0 },
        { text: '2 цифры', value: 1 },
        { text: '3 цифры', value: 2 },
        { text: '4 цифры', value: 3 },
      ],
      commands: [
        { text: '0', value: 0 },
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
        { text: '5', value: 5 },
        { text: '6', value: 6 },
        { text: '7', value: 7 },
        { text: '8', value: 8 },
        { text: '9', value: 9 },
        { text: '*', value: 10 },
        { text: '#', value: 11 },
      ],
      statuses: [
        { text: 'Отключено', value: false },
        { text: 'Включено', value: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      relay: 'Doorphone/relay',
      roleName: 'roleName',
    }),
  },
  watch: {
    'formRelay.dtmfOption': {
      handler: function (after, before) {
        this.validateFields();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      getRelay: 'Doorphone/getRelay',
      updateRelay: 'Doorphone/updateRelay',
      importRelay: 'Doorphone/importRelay',
    }),
    loadRelay () {
      this.getRelay(this.$route.params.id)
        .then(() => {
          this.formRelay.dtmfOption = this.relay.dtmf_option;
          this.formRelay.relayOnWeb = this.relay.relay_on_web;
          this.formRelay.relayAType = this.relay.relay_a_type;
          this.formRelay.relayADelay = this.relay.relay_a_delay;
          this.formRelay.relayADtmf = this.relay.relay_a_dtmf;
          this.formRelay.relayAMulticode = this.relay.relay_a_multicode;
          this.formRelay.relayBType = this.relay.relay_b_type;
          this.formRelay.relayBDelay = this.relay.relay_b_delay;
          this.formRelay.relayBDtmf = this.relay.relay_b_dtmf;
          this.formRelay.relayBMulticode = this.relay.relay_b_multicode;
          this.formRelay.relayCType = this.relay.relay_c_type;
          this.formRelay.relayCDelay = this.relay.relay_c_delay;
          this.formRelay.relayCDtmf = this.relay.relay_c_dtmf;
          this.formRelay.relayCMulticode = this.relay.relay_c_multicode;
          this.lockModes = this.relay.lock_mode;

          this.selectOption();
        })
        .catch(() => {
          this.$flash_warning('Ошибка загрузки управления замком');
        });
    },
    delays () {
      const delays = [];
      for (let i = 1; i <= 60; i++) {
        delays.push(i);
      }

      return delays;
    },
    selectOption () {
      if (this.formRelay.dtmfOption === 0) {
        this.commandDisabled = false;
        this.multicodeDisabled = true;
      } else {
        this.commandDisabled = true;
        this.multicodeDisabled = false;
      }
    },
    validateMulticode (multicode) {
      const rules = [];

      if (!this.multicodeDisabled) {
        const rule1 = v => /^[0-9\\*#]+$/.test(v) || 'Укажите корректную DTMF-команду';
        rules.push(rule1);

        const rule2 = v => multicode.length === (this.formRelay.dtmfOption + 1) ||
          'Длина строки не соответствует настройке DTMF';
        rules.push(rule2);
      }

      return rules;
    },
    validateFields () {
      this.$refs.formRelay.validate();
    },
    saveRelay () {
      if (this.validRelay) {
        const data = {
          dtmf_option: this.formRelay.dtmfOption,
          relay_on_web: this.formRelay.relayOnWeb,
          relay_a_type: this.formRelay.relayAType,
          relay_a_delay: this.formRelay.relayADelay,
          relay_b_type: this.formRelay.relayBType,
          relay_b_delay: this.formRelay.relayBDelay,
          relay_c_type: this.formRelay.relayCType,
          relay_c_delay: this.formRelay.relayCDelay,
          lock_mode: this.lockModes,
        };

        if (this.commandDisabled) {
          data.relay_a_multicode = this.formRelay.relayAMulticode;
          data.relay_b_multicode = this.formRelay.relayBMulticode;
          data.relay_c_multicode = this.formRelay.relayCMulticode;
        } else {
          data.relay_a_dtmf = this.formRelay.relayADtmf;
          data.relay_b_dtmf = this.formRelay.relayBDtmf;
          data.relay_c_dtmf = this.formRelay.relayCDtmf;
        }

        this.updateRelay({
          id: this.$route.params.id,
          data: data,
        })
          .then(() => {
            this.$flash_success('Изменения успешно сохранены');
          })
          .catch(() => {
            this.$flash_warning('Ошибка при сохранении управления замком');
          });
      } else {
        this.$flash_warning('Ошибка при заполнении формы');
      }
    },
    importRelayData () {
      this.importRelay({
        id: this.$route.params.id,
      })
        .then(() => {
          this.loadRelay();
          this.$flash_success('Импортирование реле успешно завершено');
        })
        .catch(() => {
          this.$flash_warning('Ошибка импортирования реле');
        });
    },
  },
  created () {
    if (['admin', 'admin-engineer'].includes(this.roleName)) {
      this.dtmfEnabled = true;
    }
    this.loadRelay();
  },
};
</script>

<style lang="scss" scoped>
.relay__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.relay__header-icon {
  flex-shrink: 0;
}

.relay__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.relay__mode-select {
  max-width: 280px;
}

.relay__mode-select ::v-deep .v-input__prepend-inner .v-icon {
  color: rgba(0, 0, 0, 0.5);
}

.relay__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 32px;
}

.row-height {
  height: 60px;
}
</style>
